import { render, staticRenderFns } from "./RotinasAdministrativas.vue?vue&type=template&id=07cb0c59&scoped=true"
import script from "./RotinasAdministrativas.vue?vue&type=script&lang=js"
export * from "./RotinasAdministrativas.vue?vue&type=script&lang=js"
import style0 from "./RotinasAdministrativas.vue?vue&type=style&index=0&id=07cb0c59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cb0c59",
  null
  
)

export default component.exports